import { useEffect } from "react";

interface EqualWebMenuListenerProps {
  onOpen?: () => void;
  onClose?: () => void;
}

export const EqualWebMenuListener = ({ onOpen, onClose }: EqualWebMenuListenerProps) => {
  useEffect(() => {
    const menu = document.querySelector("#INDmenu[aria-hidden]");
    const toggleButton = document.querySelector("#INDmenu-btn[aria-expanded]");

    if (!menu && !toggleButton) {
      console.warn("EqualWeb INDMenu elements not found yet.");
      return;
    }

    const handleMenuChange = (mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
          const target = mutation.target as HTMLElement;
          const isHidden = target.getAttribute("aria-hidden") === "true";

          if (isHidden && onClose) {
            onClose();
          } else if (!isHidden && onOpen) {
            onOpen();
          }
        }
      }
    };

    // Observe changes on the menu’s aria-hidden attribute
    const observer = new MutationObserver(handleMenuChange);

    if (menu) {
      observer.observe(menu, {
        attributes: true,
        attributeFilter: ["aria-hidden"],
      });
    }

    if (toggleButton) {
      observer.observe(toggleButton, {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });
    }

    return () => observer.disconnect();
  }, [onOpen, onClose]);

  return null;
};
